import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import Divider from "@mui/material/Divider";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import Select from "react-select";
import InputMask from "react-input-mask";
import Typography from "@mui/material/Typography";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import step from "assets/theme/components/stepper/step";
import CreatableSelect from "react-select/creatable";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
const AcademicsInfoCorrection = () => {
  const [campaignId, setCampaignId] = useState(null);
  const [form_no, setFormNo] = useState("");
  const [applicant_cnic, setApplicantCnic] = useState("");
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [academics, setAcademics] = useState([]);
  const [application_type, setApplicationType] = useState("");
  const [applicationId, setApplicationId] = useState(null);
  const [previousPrograms, setPreviousPrograms] = useState([]);
  const [academicErrors, setAcademicErrors] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [supervisor, setSupervisor] = useState("");
  const [proposalTitle, setProposalTitle] = useState("");
  const [proposalAttachment, setProposalAttachment] = useState("");
  const [phdFormErrors, setPhdFormErrors] = useState({});
  const [publications, setPublications] = useState([]);
  const [publicationErrors, setPublicationErrors] = useState([]);
  const getSubjects = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(
      `${BASE_URL}/submit_application/get_previous_subjects`,
      requestOptions
    );
    const result = await response.json();
    if (result.previous_subjects) {
      setSubjects(result.previous_subjects);
    }
  };
  const [universities, setUniversities] = useState([]);
  const getPreviousPrograms = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(
      `${BASE_URL}/submit_application/get_previous_programs`,
      requestOptions
    );
    const result = await response.json();
    if (result.previous_programs) {
      setPreviousPrograms(result.previous_programs);
    }
  };
  const validateAcademics = (academics) => {
    const errors = [];
    academics.forEach((academic, index) => {
      const error = {};
      if ("degree" in academic && !academic.degree) {
        error.degree = "Degree is required.";
      }

      if ("board" in academic && !academic.board) {
        error.board = "Board is required.";
      }

      if ("year" in academic && !academic.year) {
        error.year = "Year is required.";
      }

      if ("roll_no" in academic && !academic.roll_no) {
        error.roll_no = "Roll / Registration number is required.";
      }

      if ("total_marks" in academic && !academic.total_marks) {
        error.total_marks = "Total marks are required.";
      } else if (isNaN(academic.total_marks)) {
        error.total_marks = "Total marks must be a number.";
      }

      if ("obtain_marks" in academic && !academic.obtain_marks) {
        error.obtain_marks = "Obtained marks are required.";
      } else if (isNaN(academic.obtain_marks)) {
        error.obtain_marks = "Obtained marks must be a number.";
      }

      if ("division" in academic && !academic.division) {
        error.division = "Division is required.";
      }

      if ("exam_pass_in" in academic && !academic.exam_pass_in) {
        error.exam_pass_in = "Exam pass type is required.";
      }

      if ("grade" in academic && !academic.grade) {
        error.grade = "Grade is required.";
      }

      if (
        "percentage" in academic &&
        !academic.percentage &&
        academic.exam_system === "Semester"
      ) {
        error.percentage = "Percentage is required.";
      }

      if ("major_subject" in academic && !academic.major_subject) {
        error.major_subject = "Major subject is required.";
      }

      if (
        "elective_subject_one" in academic &&
        !academic.elective_subject_one
      ) {
        error.elective_subject_one = "First elective subject is required.";
      }

      if (
        "elective_subject_one_total_marks" in academic &&
        !academic.elective_subject_one_total_marks
      ) {
        error.elective_subject_one_total_marks =
          "First elective subject total marks are required.";
      }

      if (
        "elective_subject_one_obtain_marks" in academic &&
        !academic.elective_subject_one_obtain_marks
      ) {
        error.elective_subject_one_obtain_marks =
          "First elective subject obtained marks are required.";
      }

      if (
        "elective_subject_two" in academic &&
        !academic.elective_subject_two
      ) {
        error.elective_subject_two = "Second elective subject is required.";
      }

      if (
        "elective_subject_two_total_marks" in academic &&
        !academic.elective_subject_two_total_marks
      ) {
        error.elective_subject_two_total_marks =
          "Second elective subject total marks are required.";
      }

      if (
        "elective_subject_two_obtain_marks" in academic &&
        !academic.elective_subject_two_obtain_marks
      ) {
        error.elective_subject_two_obtain_marks =
          "Second elective subject obtained marks are required.";
      }

      if (
        "elective_subject_three" in academic &&
        !academic.elective_subject_three
      ) {
        error.elective_subject_three = "Third elective subject is required.";
      }

      if (
        "elective_subject_three_total_marks" in academic &&
        !academic.elective_subject_three_total_marks
      ) {
        error.elective_subject_three_total_marks =
          "Third elective subject total marks are required.";
      }

      if (
        "elective_subject_three_obtain_marks" in academic &&
        !academic.elective_subject_three_obtain_marks
      ) {
        error.elective_subject_three_obtain_marks =
          "Third elective subject obtained marks are required.";
      }
      if ("result" in academic && !academic.result) {
        error.result = "Result Attachment is required.";
      }
      if (Object.keys(error).length > 0) {
        errors[index] = error;
      }
    });
    return errors;
  };
  const handleValidation = () => {
    const validationErrors = validateAcademics(academics); // Validate academics

    setAcademicErrors(validationErrors); // Update state with validation errors

    return validationErrors.length === 0; // Return true if no errors, false otherwise
  };
  const submitAcademics = async () => {
    if (!handleValidation()) return false;
    let data = {
      step: 2,
      application_id: applicationId,
      academics: academics,
    };

    // Add PhD research proposal and publications if applicable
    if (application_type === "PH.D" || application_type === "Phd-5") {
      data.supervisor = supervisor;
      data.research_proposal_title = proposalTitle;
      data.research_proposal_attachment = proposalAttachment;
      data.publications = publications;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(
      `${BASE_URL}/submit_application/submit_academics_correction`,
      requestOptions
    );

    const result = await response.json();
    toast.success(result.error);
    if (result.success) {
      toast.success(result.success);
    } else {
      toast.error(result.message);
    }
  };
  const getUniversities = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(
      `${BASE_URL}/submit_application/get_previous_universities`,
      requestOptions
    );
    const result = await response.json();
    if (result.previous_universities) {
      setUniversities(result.previous_universities);
    }
  };
  function getDefaultAcademics(application_type) {
    if (application_type === "Undergraduate") {
      return [
        {
          type: "matric",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "inter",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          elective_subject_one: "",
          elective_subject_one_total_marks: "",
          elective_subject_one_obtain_marks: "",
          elective_subject_two: "",
          elective_subject_two_total_marks: "",
          elective_subject_two_obtain_marks: "",
          elective_subject_three: "",
          elective_subject_three_total_marks: "",
          elective_subject_three_obtain_marks: "",
          result: "",
          is_result_awaitng: "",
        },
      ];
    }

    if (application_type === "Undergraduate-5") {
      return [
        {
          type: "matric",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "inter",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "bsc",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
      ];
    }

    if (application_type === "Postgraduate") {
      return [
        {
          type: "matric",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "inter",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "bs",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          position: "",
          result: "",
        },
      ];
    }

    if (application_type === "Postgraduate-5") {
      return [
        {
          type: "matric",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "inter",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "bsc",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "ma",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          position: "",
          result: "",
        },
      ];
    }

    // ✅ PH.D (Regular - assumes BS + MPhil)
    if (application_type === "PH.D") {
      return [
        {
          type: "matric",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "inter",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "bs",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          position: "",
          result: "",
        },
        {
          type: "mphil",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
      ];
    }

    // ✅ Phd-5 (assumes BSc + MA + MPhil)
    if (application_type === "Phd-5") {
      return [
        {
          type: "matric",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "inter",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "bsc",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          exam_pass_in: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "ma",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
        {
          type: "mphil",
          exam_system: "Annual",
          degree: "",
          board: "",
          other_board: "",
          year: "",
          roll_no: "",
          total_marks: "",
          obtain_marks: "",
          division: "",
          grade: "",
          percentage: "",
          result: "",
        },
      ];
    }

    // fallback if application_type is unknown
    return [];
  }

  const fetchApplication = async () => {
  if (!campaignId) {
    toast.error("Please select a campaign.");
    return;
  }

  try {
    const payload = {
      campaign_id: campaignId,
      applicant_cnic: applicant_cnic,
      application_id: form_no,
    };

    const response = await fetch(
      BASE_URL + `/submit_application/get_application_by_cnic_or_id`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (data.error) {
      toast.error(data.error);
      return;
    }

    const application = data.application;

    // --- Base Application Data ---
    setApplicationId(application.id);
    setApplicationType(application.application_type);

    const academicTemplate = getDefaultAcademics(application.application_type);

    if (data.academics.length > 0) {
      const mergedAcademics = academicTemplate.map((templateItem) => {
        const incomingItem = data.academics.find(
          (entry) => entry.type === templateItem.type
        );

        if (incomingItem) {
          const merged = {};
          // Only take keys that exist in the template
          for (const key in templateItem) {
            merged[key] =
              key in incomingItem ? incomingItem[key] : templateItem[key];
          }
          return merged;
        }

        return templateItem; // No incoming data for this type, return default
      });

      setAcademics(mergedAcademics);
    } else {
      setAcademics(academicTemplate);
    }

    // --- Handle PhD Research Proposal ---
    if (data.phd_proposal) {
      setProposalTitle(data.phd_proposal.proposal_topic);
      setSupervisor(data.phd_proposal.supervisor); // backend should return supervisor name or ID
      setProposalAttachment(data.phd_proposal.proposal_attachment);
    } else {
      setProposalTitle("");
      setSupervisor("");
      setProposalAttachment("");
    }

    // --- Handle Research Publications ---
    if (data.publications && data.publications.length > 0) {
      setPublications(data.publications);
    } else {
      setPublications([]);
    }
  } catch (error) {
    console.log("Error fetching application:", error);
  }
};

  const handleAcademicChange = (index, field, value) => {
    const updatedAcademics = [...academics];
    let newValue = value;

    // Convert value to number for numeric fields
    if (
      field === "total_marks" ||
      field === "obtain_marks" ||
      field === "percentage" ||
      field.includes("_total_marks") ||
      field.includes("_obtain_marks")
    ) {
      newValue = parseFloat(value);
    }

    // Validation for Total Marks in Semester system
    if (
      field === "total_marks" &&
      updatedAcademics[index].exam_system === "Semester" &&
      newValue > 5.0
    ) {
      toast.error("Total CGPA cannot exceed 5.0");
      return;
    }

    if (field === "percentage" && newValue > 100) {
      toast.error("Percentage cannot exceed 100%");
      return;
    }

    // Validation for Obtain Marks being less than Total Marks
    if (
      field === "obtain_marks" &&
      newValue > updatedAcademics[index].total_marks
    ) {
      toast.error(
        "Obtained Marks / CGPA cannot be greater than Total Marks / CGPA"
      );
      return;
    }

    // Validation for elective subjects
    if (
      field === "elective_subject_one_obtain_marks" &&
      newValue > updatedAcademics[index].elective_subject_one_total_marks
    ) {
      toast.error(
        "Elective Subject One Obtained Marks cannot be greater than Total Marks"
      );
      return;
    }

    if (
      field === "elective_subject_two_obtain_marks" &&
      newValue > updatedAcademics[index].elective_subject_two_total_marks
    ) {
      toast.error(
        "Elective Subject Two Obtained Marks cannot be greater than Total Marks"
      );
      return;
    }

    if (
      field === "elective_subject_three_obtain_marks" &&
      newValue > updatedAcademics[index].elective_subject_three_total_marks
    ) {
      toast.error(
        "Elective Subject Three Obtained Marks cannot be greater than Total Marks"
      );
      return;
    }

    updatedAcademics[index][field] = newValue;
    setAcademics(updatedAcademics);
  };

  const fetchAllCampaigns = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(
        BASE_URL + `/campaign/get_campaigns`,
        requestOptions
      );
      const data = await response.json();
      setAllCampaigns(data.campaigns);
    } catch (error) {
      console.log("Error fetching campaigns:", error);
    }
  };
  const handleCampaignChange = (selectedOption) => {
    setCampaignId(selectedOption.value);
  };
  useEffect(() => {
    fetchAllCampaigns();
    getPreviousPrograms();
    getSubjects();
    getUniversities();
  }, []);
  // Add these handler functions:
  const handleAddPublication = () => {
    const newPublication = {
      id: Date.now(), // Simple ID generation
      title: "",
      name_of_journal: "",
      year: "",
      volume: "",
      issue: "",
      page_nos: "",
      hec_recognized: false,
    };
    setPublications([...publications, newPublication]);
  };

  const handlePublicationChange = (index, field, value) => {
    const updatedPublications = [...publications];
    updatedPublications[index][field] = value;
    setPublications(updatedPublications);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Campaigns
                </MDTypography>
                <Select
                  name="campaign_id"
                  options={all_campaigns.map((camp) => ({
                    value: camp.id,
                    label: camp.name,
                  }))}
                  className="basic-single-select"
                  classNamePrefix="select"
                  placeholder="Select Campaign"
                  onChange={handleCampaignChange}
                  value={
                    all_campaigns
                      .map((camp) => ({
                        value: camp.id,
                        label: camp.name,
                      }))
                      .find((option) => option.value === campaignId) || null
                  }
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Form No
                </MDTypography>
                <MDInput
                  type="text"
                  label="Form No"
                  fullWidth
                  value={form_no}
                  onChange={(e) => setFormNo(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  CNIC
                </MDTypography>
                <MDInput
                  type="text"
                  label="CNIC"
                  fullWidth
                  value={applicant_cnic}
                  onChange={(e) => setApplicantCnic(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <MDBox mt={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ width: "100%", color: "white" }}
                    onClick={fetchApplication}
                  >
                    Fetch Application
                  </Button>
                </MDBox>
              </div>
            </Stack>
          </Grid>
        </Grid>
        <div className="row mt-2 mb-2">
          <div className="col-md-12 mt-2 mb-2 text-danger">
            <h4>
              Note: Any type of academic correction will result in removal from
              merit lists if an application already exists
            </h4>
          </div>
        </div>
        <div className="row">
          {academics.map((academic, index) => (
            <>
              <div
                key={academic.id || index}
                className="col-md-12 mt-3 mb-3 text-center"
              >
                {academic.type === "matric" && (
                  <>
                    <Typography variant="h5">
                      Matric / O Level or Equivalent Detail
                    </Typography>
                    <Divider />
                  </>
                )}
                {academic.type === "inter" && (
                  <>
                    <Typography variant="h5">
                      F.A / F.Sc / ICS / D.Com / DBA / A Level or Equivalent
                    </Typography>
                    <Divider />
                  </>
                )}
                {academic.type === "bs" && (
                  <>
                    <Typography variant="h5">
                      BS/B.Sc Hons. 4 Years or Equivalent
                    </Typography>
                    <Divider />
                  </>
                )}
                {academic.type === "mphil" && (
                  <>
                    <Typography variant="h5">M.Phil Detail</Typography>
                    <Divider />
                  </>
                )}
                {academic.type === "bsc" && (
                  <>
                    <Typography variant="h5">
                      B.A / B.Sc / B.Com / BBA or Equivalent Detail
                    </Typography>
                    <Divider />
                  </>
                )}
                {academic.type === "ma" && (
                  <>
                    <Typography variant="h5">
                      M.A / M.Sc or Equivalent Detail
                    </Typography>
                    <Divider />
                  </>
                )}
              </div>
              {"degree" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Degree
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="degree"
                      value={academic.degree || ""} // Safe access
                      onChange={(e) =>
                        handleAcademicChange(index, "degree", e.target.value)
                      }
                      className="form-control form-control-lg"
                      required
                    >
                      <option value="" disabled>
                        Select Degree
                      </option>
                      {previousPrograms
                        .filter((program) => program.type === academic.type)
                        .map((program) => (
                          <option key={program.id} value={program.name}>
                            {program.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.degree || ""}
                  </div>
                </div>
              )}
              {"exam_system" in academic &&
                academic.type !== "matric" &&
                academic.type !== "inter" && (
                  <div className="col-md-4">
                    <div className="form-outline mt-3">
                      <label>
                        Exam System
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="exam_system"
                        value={academic.exam_system || ""} // Safe access
                        onChange={(e) =>
                          handleAcademicChange(
                            index,
                            "exam_system",
                            e.target.value
                          )
                        }
                        className="form-control form-control-lg"
                        required
                      >
                        <option value="Annual">Annual System</option>
                        <option value="Semester">Semester System</option>
                      </select>
                    </div>
                    <div className="error-message1">
                      {academicErrors?.[index]?.exam_system || ""}{" "}
                      {/* Safe access */}
                    </div>
                  </div>
                )}
              {"board" in academic && (
                <>
                  <div className="col-md-4">
                    <div className="form-outline mt-3">
                      <label>
                        Board / Institute{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="board"
                        value={academic.board || ""} // Safe access
                        onChange={(e) =>
                          handleAcademicChange(index, "board", e.target.value)
                        }
                        className="form-control form-control-lg"
                        required
                      >
                        <option value="" disabled>
                          Select Board / Institute
                        </option>
                        {universities
                          .filter((university) =>
                            academic.type === "matric" ||
                            academic.type === "inter"
                              ? university.type === "board"
                              : university.type === "university"
                          )
                          .map((university) => (
                            <option key={university.id} value={university.name}>
                              {university.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="error-message1">
                      {academicErrors?.[index]?.board || ""} {/* Safe access */}
                    </div>
                  </div>
                  {academic.board === "Other" && (
                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Other Board / Institute Name</label>
                        <input
                          type="text"
                          name="other_board"
                          value={academic.other_board || ""}
                          onChange={(e) =>
                            handleAcademicChange(
                              index,
                              "other_board",
                              e.target.value
                            )
                          }
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
              {"year" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Year
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="year"
                      value={academic.year || ""}
                      onChange={(e) =>
                        handleAcademicChange(index, "year", e.target.value)
                      }
                      className="form-control form-control-lg"
                      required
                    >
                      <option value="">Select Year</option>
                      {Array.from(
                        {
                          length: new Date().getFullYear() - 1980 + 1,
                        },
                        (_, i) => 1980 + i
                      ).map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.year || ""}
                  </div>
                </div>
              )}
              {"roll_no" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Roll / Registration Number{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="roll_no"
                      placeholder="Roll / Registration Number"
                      value={academic.roll_no || ""}
                      onChange={(e) =>
                        handleAcademicChange(index, "roll_no", e.target.value)
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.roll_no || ""}
                  </div>
                </div>
              )}
              {"total_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      {academic.exam_system === "Semester"
                        ? "Total CGPA"
                        : "Total Marks"}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="total_marks"
                      placeholder={
                        academic.exam_system === "Semester"
                          ? "Total CGPA"
                          : "Total Marks"
                      }
                      value={academic.total_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "total_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.total_marks || ""}
                  </div>
                </div>
              )}
              {"obtain_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      {academic.exam_system === "Semester"
                        ? "Obtained CGPA"
                        : "Obtained Marks"}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="obtain_marks"
                      placeholder={
                        academic.exam_system === "Semester"
                          ? "Obtained CGPA"
                          : "Obtained Marks"
                      }
                      value={academic.obtain_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "obtain_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.obtain_marks || ""}
                  </div>
                </div>
              )}
              {"division" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Division <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="division"
                      value={academic.division || ""}
                      onChange={(e) =>
                        handleAcademicChange(index, "division", e.target.value)
                      }
                      className="form-control form-control-lg"
                      required
                    >
                      <option value="" disabled>
                        Select Division
                      </option>
                      <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd">3rd</option>
                    </select>
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.division || ""}
                  </div>
                </div>
              )}
              {"exam_pass_in" in academic &&
                (academic.exam_system === "Annual" ||
                  academic.type === "bsc" ||
                  academic.type === "ma" ||
                  academic.type === "bs") && (
                  <div className="col-md-4">
                    <div className="form-outline mt-3">
                      <label>
                        Exam Passed In <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="exam_pass_in"
                        value={academic.exam_pass_in || ""}
                        onChange={(e) =>
                          handleAcademicChange(
                            index,
                            "exam_pass_in",
                            e.target.value
                          )
                        }
                        className="form-control form-control-lg"
                        required
                      >
                        <option value="" disabled>
                          Select Exam Type
                        </option>
                        <option value="Annual">Annual</option>
                        <option value="Supply">Supply</option>
                      </select>
                    </div>
                    <div className="error-message1">
                      {academicErrors?.[index]?.exam_pass_in || ""}
                    </div>
                  </div>
                )}
              {"grade" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Grade <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="grade"
                      value={academic.grade || ""}
                      onChange={(e) =>
                        handleAcademicChange(index, "grade", e.target.value)
                      }
                      className="form-control form-control-lg"
                      required
                    >
                      <option value="" disabled>
                        Select Grade
                      </option>
                      <option value="A+">A+</option>
                      <option value="A">A</option>
                      <option value="B+">B+</option>
                      <option value="B">B</option>
                      <option value="C+">C+</option>
                      <option value="C">C</option>
                      <option value="D+">D+</option>
                      <option value="D">D</option>
                    </select>
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.grade || ""}
                  </div>
                </div>
              )}
              {"percentage" in academic &&
                academic.exam_system === "Semester" && (
                  <div className="col-md-4">
                    <div className="form-outline mt-3">
                      <label>
                        Percentage <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="number"
                        name="percentage"
                        placeholder="Percentage"
                        value={academic.percentage || ""}
                        onChange={(e) =>
                          handleAcademicChange(
                            index,
                            "percentage",
                            e.target.value
                          )
                        }
                        className="form-control form-control-lg"
                        required
                      />
                    </div>
                    <div className="error-message1">
                      {academicErrors?.[index]?.percentage || ""}
                    </div>
                  </div>
                )}
              {"major_subject" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Major Subject <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="major_subject"
                      value={academic.major_subject || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "major_subject",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    >
                      <option value="" disabled>
                        Select Major Subject
                      </option>
                      {subjects.map((subject) => (
                        <option key={subject.id} value={subject.name}>
                          {subject.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.major_subject || ""}
                  </div>
                </div>
              )}
              {"position" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Position</label>
                    <select
                      name="position"
                      value={academic.position || ""}
                      onChange={(e) =>
                        handleAcademicChange(index, "position", e.target.value)
                      }
                      className="form-control form-control-lg"
                      required
                    >
                      <option value="">Select Position</option>
                      <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd">3rd</option>
                    </select>
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.position || ""}
                  </div>
                </div>
              )}
              {"elective_subject_one" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject One{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <CreatableSelect
                      isClearable
                      name="elective_subject_one"
                      classNamePrefix="select"
                      value={
                        academic.elective_subject_one
                          ? {
                              label: academic.elective_subject_one,
                              value: academic.elective_subject_one,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_one",
                          selectedOption ? selectedOption.value : ""
                        )
                      }
                      options={subjects.map((subject) => ({
                        label: subject.name,
                        value: subject.name,
                      }))}
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.elective_subject_one || ""}
                  </div>
                </div>
              )}
              {"elective_subject_one_total_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject One Total Marks{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="elective_subject_one_total_marks"
                      placeholder="Elective Subject One Total Marks"
                      value={academic.elective_subject_one_total_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_one_total_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]
                      ?.elective_subject_one_total_marks || ""}
                  </div>
                </div>
              )}
              {"elective_subject_one_obtain_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject One Obtained Marks{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="elective_subject_one_obtain_marks"
                      placeholder="Elective Subject One Obtained Marks"
                      value={academic.elective_subject_one_obtain_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_one_obtain_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]
                      ?.elective_subject_one_obtain_marks || ""}
                  </div>
                </div>
              )}
              {"elective_subject_two" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject Two{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <CreatableSelect
                      isClearable
                      name="elective_subject_two"
                      classNamePrefix="select"
                      value={
                        academic.elective_subject_two
                          ? {
                              label: academic.elective_subject_two,
                              value: academic.elective_subject_two,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_two",
                          selectedOption ? selectedOption.value : ""
                        )
                      }
                      options={subjects.map((subject) => ({
                        label: subject.name,
                        value: subject.name,
                      }))}
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.elective_subject_two || ""}
                  </div>
                </div>
              )}
              {"elective_subject_two_total_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject Two Total Marks{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="elective_subject_two_total_marks"
                      placeholder="Elective Subject Two Total Marks"
                      value={academic.elective_subject_two_total_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_two_total_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]
                      ?.elective_subject_two_total_marks || ""}
                  </div>
                </div>
              )}
              {"elective_subject_two_obtain_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject Two Obtained Marks{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="elective_subject_two_obtain_marks"
                      placeholder="Elective Subject Two Obtained Marks"
                      value={academic.elective_subject_two_obtain_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_two_obtain_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]
                      ?.elective_subject_two_obtain_marks || ""}
                  </div>
                </div>
              )}
              {"elective_subject_three" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject Three{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <CreatableSelect
                      isClearable
                      name="elective_subject_three"
                      classNamePrefix="select"
                      value={
                        academic.elective_subject_three
                          ? {
                              label: academic.elective_subject_three,
                              value: academic.elective_subject_three,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_three",
                          selectedOption ? selectedOption.value : ""
                        )
                      }
                      options={subjects.map((subject) => ({
                        label: subject.name,
                        value: subject.name,
                      }))}
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.elective_subject_three || ""}
                  </div>
                </div>
              )}
              {"elective_subject_three_total_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject Three Total Marks{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="elective_subject_three_total_marks"
                      placeholder="Elective Subject Three Total Marks"
                      value={academic.elective_subject_three_total_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_three_total_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]
                      ?.elective_subject_three_total_marks || ""}
                  </div>
                </div>
              )}
              {"elective_subject_three_obtain_marks" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Elective Subject Three Obtained Marks{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      name="elective_subject_three_obtain_marks"
                      placeholder="Elective Subject Three Obtained Marks"
                      value={academic.elective_subject_three_obtain_marks || ""}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "elective_subject_three_obtain_marks",
                          e.target.value
                        )
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]
                      ?.elective_subject_three_obtain_marks || ""}
                  </div>
                </div>
              )}
              {"result" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Result Attachment <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="file"
                      name="result"
                      placeholder="Result"
                      accept=".png,.jpeg,.jpg,.pdf"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onload = () => {
                            const base64String = reader.result; // Extract base64 content
                            academic.result = base64String; // Set the Base64 string in academic.result
                          };
                          reader.readAsDataURL(file); // Convert file to Base64
                        }
                      }}
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message1">
                    {academicErrors?.[index]?.result || ""}
                  </div>
                  {academic.result !== "" && (
                    <div className="error-message1">
                      <a
                        href={academic.result}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                    </div>
                  )}
                </div>
              )}
              {"is_result_awaitng" in academic && (
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Result Awaiting <span className="text-danger"> *</span>
                    </label>
                    <select
                      className="form-control"
                      name="result_awaiting"
                      value={academic.is_result_awaitng}
                      onChange={(e) =>
                        handleAcademicChange(
                          index,
                          "is_result_awaitng",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select an option</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                </div>
              )}
            </>
          ))}
          {application_type === "PH.D" || application_type === "Phd-5" ? (
            <>
              <div className="row mt-4">
                <div className="col-md-12 text-center">
                  <b>Enter Your PhD Research Proposal details</b>
                </div>
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Enter Supervisor <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="supervisor"
                      value={supervisor}
                      onChange={(e) => setSupervisor(e.target.value)}
                      placeholder="Enter Supervisor Name"
                    />
                    <div className="error-message1">
                      {phdFormErrors?.supervisor || ""}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Research Proposal Title{" "}
                      <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      name="research_proposal_title"
                      placeholder="Research Proposal Title"
                      value={proposalTitle}
                      onChange={(e) => setProposalTitle(e.target.value)}
                      className="form-control form-control-lg"
                      required
                    />
                    <div className="error-message1">
                      {phdFormErrors?.proposalTitle || ""}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>
                      Research Proposal Attachment{" "}
                      <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="file"
                      name="research_proposal"
                      placeholder="Research Proposal"
                      accept=".pdf"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onload = () => {
                            const base64String = reader.result; // Extract base64 content
                            setProposalAttachment(base64String); // Set the Base64 string in research_proposal
                          };
                          reader.readAsDataURL(file); // Convert file to Base64
                        }
                      }}
                      className="form-control form-control-lg"
                      required
                    />
                    <div className="error-message1">
                      {phdFormErrors?.proposalAttachment || ""}
                    </div>
                    {proposalAttachment !== "" && (
                      <div className="error-message1">
                        <a
                          href={proposalAttachment}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : null}

          {/* Publications Section - Only for PhD applications */}
          {(application_type === "PH.D" || application_type === "Phd-5") && (
            <>
              <div className="col-md-12 box mt-4 mb-3 text-center">
                <h5>Research Publications</h5>
                <div className="mt-2 mb-2">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleAddPublication}
                  >
                    Add Publication
                  </button>
                </div>
              </div>

              {publications.length === 0 && (
                <div className="col-md-12 text-center text-muted mb-3">
                  <p>
                    No publications added yet. Click Add Publication to add your
                    research publications.
                  </p>
                </div>
              )}

              {publications.map((publication, pubIndex) => (
                <div
                  key={publication.id || pubIndex}
                  className="col-md-12 border p-3 mb-3"
                >
                  <h6 className="text-primary">Publication {pubIndex + 1}</h6>

                  <div className="row">
                    <div className="col-md-6">
                      <label>
                        Publication Title <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        value={publication.title}
                        onChange={(e) =>
                          handlePublicationChange(
                            pubIndex,
                            "title",
                            e.target.value
                          )
                        }
                        className="form-control"
                        placeholder="Enter publication title"
                      />
                      <div className="error-message1">
                        {publicationErrors?.[pubIndex]?.title || ""}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label>
                        Journal Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        value={publication.name_of_journal}
                        onChange={(e) =>
                          handlePublicationChange(
                            pubIndex,
                            "name_of_journal",
                            e.target.value
                          )
                        }
                        className="form-control"
                        placeholder="Enter journal name"
                      />
                      <div className="error-message1">
                        {publicationErrors?.[pubIndex]?.name_of_journal || ""}
                      </div>
                    </div>

                    <div className="col-md-3 mt-3">
                      <label>
                        Publication Year <span className="text-danger">*</span>
                      </label>
                      <select
                        value={publication.year}
                        onChange={(e) =>
                          handlePublicationChange(
                            pubIndex,
                            "year",
                            e.target.value
                          )
                        }
                        className="form-control"
                      >
                        <option value="">Select Year</option>
                        {Array.from(
                          {
                            length: new Date().getFullYear() - 1980 + 1,
                          },
                          (_, i) => new Date().getFullYear() - i
                        ).map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                      <div className="error-message1">
                        {publicationErrors?.[pubIndex]?.year || ""}
                      </div>
                    </div>

                    <div className="col-md-3 mt-3">
                      <label>Volume</label>
                      <input
                        type="text"
                        value={publication.volume}
                        onChange={(e) =>
                          handlePublicationChange(
                            pubIndex,
                            "volume",
                            e.target.value
                          )
                        }
                        className="form-control"
                        placeholder="Enter volume"
                      />
                    </div>

                    <div className="col-md-3 mt-3">
                      <label>Issue</label>
                      <input
                        type="text"
                        value={publication.issue}
                        onChange={(e) =>
                          handlePublicationChange(
                            pubIndex,
                            "issue",
                            e.target.value
                          )
                        }
                        className="form-control"
                        placeholder="Enter issue"
                      />
                    </div>

                    <div className="col-md-3 mt-3">
                      <label>Page Numbers</label>
                      <input
                        type="text"
                        value={publication.page_nos}
                        onChange={(e) =>
                          handlePublicationChange(
                            pubIndex,
                            "page_nos",
                            e.target.value
                          )
                        }
                        className="form-control"
                        placeholder="e.g., 123-135"
                      />
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          checked={publication.hec_recognized}
                          onChange={(e) =>
                            handlePublicationChange(
                              pubIndex,
                              "hec_recognized",
                              e.target.checked
                            )
                          }
                          className="form-check-input"
                          id={`hec_${pubIndex}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`hec_${pubIndex}`}
                        >
                          Is HEC Recognized Journal?
                        </label>
                      </div>
                    </div>
                    <div className="col-md-1 text-right">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                          const updatedPublications = publications.filter(
                            (_, index) => index !== pubIndex
                          );
                          setPublications(updatedPublications);
                        }}
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
          <div className="col-md-10 mt-2"></div>
          <div className="col-md-2 mt-2">
            {applicationId !== null && (
              <Button
                variant="contained"
                color="primary"
                style={{ width: "100%", color: "white" }}
                onClick={submitAcademics}
              >
                Submit
              </Button>
            )}
          </div>
        </div>
      </MDBox>
    </DashboardLayout>
  );
};

export default AcademicsInfoCorrection;
